import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import Box from '@material-ui/core/Box'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import SettingsIcon from '@material-ui/icons/Settings'
import AddIcon from '@material-ui/icons/Add'
import Divider from '@material-ui/core/Divider'
import ToggleButton from '@material-ui/lab/ToggleButton'
import { makeStyles } from '@material-ui/core/styles'
import Popper from '@material-ui/core/Popper'
import Paper from '@material-ui/core/Paper'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import loginActions from './../../actions/login'
import * as Constants from './../../application/constants'
import MenuIcon from '@material-ui/icons/Menu'
import { toggleDebug, toggleShowCompanies } from 'actions/user'
import { 
  Button, 
  Checkbox, 
  Dialog, 
  DialogContent, 
  DialogTitle, 
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from '@material-ui/core'
import PermissionProvider from 'components/provider/permission'
import { insertCompany } from 'actions/company'

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 35,
    width: 35
  },
  button: {
    color: theme.palette.text.primary,
    textTransform: 'initial',
    // We are giving the box a minHeight to sort out display issues
    // on an iPad. If the overall topBar height changes, this will have to change
    // as well.
    height: theme.toolbarHeight,
    borderRadius: 0,
    border: 'none',
    padding: 0
  },
  menuIcon: {
    fontSize: 28,
    color: theme.palette.text.primary
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120,
    '& .MuiSelect-outlined': {
      paddingTop: '18.5px',
      paddingBottom: '18.5px',
    }
  }
}))

const ProfileSummary = ({ email, firstname, surname, onLogout, onNavigate }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [openMenu, setOpenMenu] = useState(null)
  const [companyModalOpen, setCompanyModalOpen] = useState(false)
  const [companyName, setCompanyName] = useState()
  const [selectedCompanyType, setSelectedCompanyType] = useState()
  const [companyTypeError, setCompanyTypeError] = useState(false)
  
  const debugMode = useSelector((state) => (state._user.debugMode))
  //TODO: Fetch showCompanies boolean from the user state
  const showCompanies = useSelector((state) => (state._user.showCompanies))
  const companyId = useSelector((state) => state._user.impersonate?.companyId || state.auth?.companyId); // Get the companyId from the user state (Parent Company)
  const companyType = useSelector((state) => state._user.impersonate?.companyType || state.auth.payload?.companyType);

  const currentCompanyType = () => { 
    const currentCompanyType = companyType;
    if(currentCompanyType == '1'){
      return '';
    }
    return currentCompanyType;
  }
  
  useEffect(() => {
    console.log('The companyId is', companyId);
  }, [])

  const handleInsertCompany = async () => {
    
    if (!selectedCompanyType) {
      setCompanyTypeError(true);
      return;
    }
    
    setCompanyTypeError(false);
    
    //Also include the company of the user making the creation---> THE PARENT COMPANY
    await dispatch(insertCompany(companyName, companyId, selectedCompanyType))
    setCompanyModalOpen(false)
  }

  const toggle = () => {
    dispatch(toggleDebug(), [dispatch])
    setDebug(!debugMode)
  }
  
  const toggleCompanies = () => {
    dispatch(toggleShowCompanies(), [dispatch])
    setDisplayCompanies(!displayCompanies)
  }

  const [debug, setDebug] = useState(debugMode)
  //State to check for whether companies can be viewed.
  const [displayCompanies, setDisplayCompanies] = useState(showCompanies);// For now, we'll just use booleans and then later, we'll just migrate to redux.

  

  useEffect(() => { 
    setCompanyName(undefined)
    setSelectedCompanyType(currentCompanyType)
    setCompanyTypeError(false) // Reset error state
  }, [companyModalOpen])

  // Determine if the form is valid
  const isFormValid = () => {
    if (!companyName || !companyName.trim()) return false;
    return Boolean(selectedCompanyType);
  };

  return (
    <React.Fragment>
      <Box p={2} py={0} height="100%" display="flex" justifyContent="center" alignItems="center" flexDirection="row">
        <ToggleButton
          value={email}
          selected={Boolean(openMenu)}
          className={classes.button}
          onClick={(e) => setOpenMenu(openMenu ? null : e.currentTarget)}>
          <Box display="flex">
            <MenuIcon fontSize="large" />
          </Box>
        </ToggleButton>
      </Box>
      <Popper
        open={Boolean(openMenu)}
        anchorEl={openMenu}
        placement="bottom"
        disablePortal>
        <Paper>
          <Box py={1}>
            <Box px={2}>
              <List dense disablePadding>
                <ListItem disableGutters disabled>
                  <ListItemText primary="email" secondary={email} />
                </ListItem>
              </List>
            </Box>
            <Box p={1}>
              <Divider />
            </Box>
            <Box>
              <List dense disablePadding>
                <ListItem button onClick={() => onNavigate(Constants.PATH.ACCOUNT_PROFILE)}>
                  <ListItemIcon>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Settings" />
                </ListItem>
              </List>
            </Box>
            <PermissionProvider>
              {({ [Constants.PERMISSION.ERGOSENSE]: ergosense, [Constants.PERMISSION.ADMIN]: admin }) => {
                return (
                  <Box>
                    <List dense disablePadding>
                      { ergosense && (
                      <ListItem button onClick={() => toggle()}>
                        <ListItemIcon>
                          <Checkbox
                            edge="start"
                            checked={debug}
                            disableRipple
                          />
                        </ListItemIcon>
                        <ListItemText primary="Debug Mode" />
                      </ListItem>
                      )}
                      {admin && (
                       
                      <ListItem button onClick={() => setCompanyModalOpen(true)}>
                        <ListItemIcon>
                          <ListItemIcon>
                            <AddIcon />
                          </ListItemIcon>
                        </ListItemIcon>
                        <ListItemText primary="Add Company" />
                      </ListItem>)}
                    </List>
                  </Box>
                )
              }}
            </PermissionProvider>
            <Box p={1}>
              <Divider />
            </Box>
            <Box>
              <List dense disablePadding>
                <ListItem button onClick={onLogout}>
                  <ListItemIcon><ExitToAppIcon /></ListItemIcon>
                  <ListItemText primary="Logout" />
                </ListItem>
              </List>
            </Box>
          </Box>
        </Paper>
      </Popper>
      <Dialog
        open={companyModalOpen}
        onClose={() => setCompanyModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle >
          <Box display="flex" alignItems="center">
            Add Company
          </Box>
        </DialogTitle>
        <DialogContent>
          
          <PermissionProvider>
            {({ [Constants.PERMISSION.ADMIN]: admin}) =>{ 
            return( admin &&
              <Box>
              <FormControl 
                fullWidth 
                variant="outlined" 
                className={classes.formControl}
                error={companyTypeError}
              >
                <InputLabel >Select Company Type</InputLabel>
                <Select
                  value={selectedCompanyType || ''}
                  onChange={(e) => {
                    setSelectedCompanyType(e.target.value);
                    if (companyTypeError) setCompanyTypeError(false); // Clear error when user selects
                  }}
                  label="Select Company Type"
                >
                  <MenuItem value={2}>Ergosense</MenuItem>
                  <MenuItem value={3}>Terrasense</MenuItem>
                </Select>
                {companyTypeError && (
                  <FormHelperText>Please select a company type</FormHelperText>
                )}
              </FormControl>

              <TextField
                autoFocus={selectedCompanyType !== undefined}
                error={false}
                name="companyName"
                label="Enter Company Name"
                type="text"
                fullWidth
                variant="outlined"
                value={companyName || ''}
                onChange={(e) => setCompanyName(e.target.value)}
                onBlur={(e) => setCompanyName(e.target.value)} 
                disabled={!selectedCompanyType}
                className={classes.formControl}
              />
            </Box>
            )}}
          </PermissionProvider>

          <Divider />
          <Box pt={4} pb={2} display="flex" justifyContent="flex-end">
            <Button 
              disabled={!isFormValid()} 
              onClick={handleInsertCompany} 
              variant="contained" 
              color="primary"
            >
              Add Company
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

ProfileSummary.propTypes = {
  email: PropTypes.string.isRequired
}

export default ProfileSummary

export const Connected = (props) => {
  const dispatch = useDispatch()

  props = {
    ...props,
    email: useSelector((state) => state.auth.payload.email),
    firstname: useSelector((state) => state.auth.payload.firstname),
    surname: useSelector((state) => state.auth.payload.surname),
    onLogout: useCallback(() => dispatch(loginActions.logout()), [dispatch]),
    onNavigate: (path) => dispatch(push(path))
  }

  return <ProfileSummary {...props} />
}